<template>
  <div class="full-height">
    <div class="container-crud q-px-sm">
      <q-card class="q-px-sm">
        <div style="tw-ml-[30px]">
          <div
            v-for="state in jsonState(forms[0].dadosForm.unitStateSamae)"
            :key="state.id"
            :style="`background-color: ${stateSamae[state.chCodigo].cor}; margin: 3px; padding: 5px 30px; float: left; border-radius: 10px;`"
          >
            {{ state.nmDescricao }}
          </div>
        </div>
        <q-card-section class="row fit q-py-xs">
          <q-card class="col-3 q-px-sm">
            <q-card-section class="row q-py-xs">
              <div class="col-6 crud-title">
                <translate>SAMAE_SHIPPING</translate>
              </div>
              <div class="col-6">
                <button class="sub-teble-btn" @click="detail">
                  <q-icon name="visibility" />
                  <q-tooltip
                    anchor="bottom middle"
                    self="top middle"
                    content-style="font-size: 13px"
                    :offset="[5, 5]"
                  >
                  <translate>DETAIL</translate>
                  </q-tooltip>
                </button>

                <button class="sub-teble-btn" @click="connectUnit">
                  <q-icon name="check" />
                  <q-tooltip
                    anchor="bottom middle"
                    self="top middle"
                    content-style="font-size: 13px"
                    :offset="[5, 5]"
                  >
                  <translate>CREATE_NEW_CONSUMER_UNIT</translate>
                  </q-tooltip>
                </button>
              </div>
            </q-card-section>
            <q-card-section
              class="data-card-main grid-layout"
              style="tw-mt-[2px]"
            >
              <div
                v-for="(obj, index) in computedInputsTypeElements"
                :key="index"
                :class="getClassesByTheElement(obj)"
              >
                <label>{{ obj.label }}:</label>
                {{ formatedValue(model[obj.name], obj) }}
              </div>
            </q-card-section>
          </q-card>

          <div class="col-9" style="padding-left: 25px">
            <q-card class="q-px-sm">
              <q-card-section class="row q-py-xs">
                <div class="col-10 crud-title">
                  <translate>REGISTRATION_WASTE</translate>
                </div>
                <div class="col-2">
                  <button class="sub-teble-btn" @click="searchModalUnit">
                    <q-icon name="filter_list" />
                    {{ $gettext("FILTER") }}
                  </button>
                </div>
              </q-card-section>

              <q-scroll-area style="height: 350px">
                <jt-data-table
                  v-if="datatableConsumerUnit"
                  :api-mode="false"
                  :data="dataConsumerUnit"
                  :buttons="datatableConsumerUnit.buttons"
                  :fields="datatableConsumerUnit.columns"
                  noneselect
                  :is-paginated="false"
                  @action-button="btnActionUnit"
                />
              </q-scroll-area>
            </q-card>
          </div>
          <consumer-unit-page
            v-if="showFormUnit"
            ref="consumerUnitForm"
            class="col-12"
            id="analyzeSamae"
            :forms="forms[2]"
            name="consumer-unit-page"
            hidden-buttons
          />
          <div class="row full-width q-col-gutter-lg justify-center q-pt-md">
            <div class="col-lg-2 col-md-3">
              <q-btn
                :disable="!!dadosForm.user"
                class="full-width"
                color="info"
                @click="btAssociar"
              >
                <translate>CONNECT</translate>
              </q-btn>
            </div>
            <div class="col-lg-2 col-md-3">
              <q-btn
                :disable="!dadosForm.user"
                class="full-width"
                color="info"
                @click="btAnalisar"
              >
                <translate>ANALYZE</translate>
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
      <q-dialog v-if="flModal" v-model="flModal">
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>{{ pageDialog.name }}</q-toolbar-title>
              <q-btn
                v-close-popup
                flat
                round
                dense
                size="1.5em"
                icon="cancel"
              />
            </q-toolbar>
          </q-header>
          <q-page-container class="card-container-modal">
            <component
              :is="pageDialog.page"
              :name="pageDialog.name"
              :params="pageDialog.params"
              :forms="pageDialog.forms"
              :datatable="pageDialog.datatable"
              :parent="pageDialog.parent"
              inside-modal
              @action-button="actionButton"
              @show-message="showMessage"
            />
          </q-page-container>
        </q-layout>
      </q-dialog>
      <q-dialog ref="jtSearchModal">
        <jt-pesquisa-content
          :nm-interface="nmInterfaceSearchModalUnit"
          :extra-params="{}"
          :multiselect="true"
          @resultSelect="getSelectedItemData"
        />
      </q-dialog>
    </div>
    <q-dialog v-model="modalUnitStateSamae.show" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">{{ modalUnitStateSamae.message }}</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input
            placeholder="Observação"
            dense
            v-model="modalUnitStateSamae.observation"
            autofocus
          />
          <b style="font-size: 10px; color: rgb(129, 55, 55)"
            >*<translate>OBSERVATION_IS_MANDATORY</translate></b
          >
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat :label="$gettext('CANCEL')" v-close-popup />
          <q-btn
            :disabled="!!!modalUnitStateSamae.observation"
            flat
            :label="$gettext('YES')"
            v-close-popup
            @click="modalUnitStateSamae.click"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <import-data-alert :alert="showImportAlert" @import-data="importData" @input="(val) => showImportAlert = val"/>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'src/jtech/jtech-repository'
import SamaeController from '../SamaeController'
import pageDetailSamae from './PageDetail'
import unitStateSamae from '../UnitStateSamae.config.js'
import { JtDataTable, JtPesquisaContent, JtCrud } from 'jtech-webcomps'
const { pageDetail, CrudLayoutSearch, form, input } = JtCrud
import consumerUnitPage from 'src/modules/consumer-unit/ConsumerUnitPage.vue'
import { messageBox } from 'jtech'
import ImportDataAlert from './ImportDataAlert.vue'
@Component({
  name: 'PageAnalyze',
  mixins: [pageDetail],
  components: {
    JtDataTable,
    CrudLayoutSearch,
    pageDetail,
    JtPesquisaContent,
    consumerUnitPage,
    'crud-form': form,
    'crud-input': input,
    ImportDataAlert
  }
})
class PageAnalyze extends Vue {
  controller = SamaeController.getInstance();
  stateSamae = unitStateSamae;
  pageDialog = null;
  flModal = false;
  dadosForm = { user: null };
  nmInterfaceConsumerUnit = 'samae.pesquisarConsumerUnit';
  nmInterfaceSearchModalUnit = 'consumerUnit.pesquisar';
  datatableConsumerUnit = null;
  dataConsumerUnit = [];
  datatable = null;
  data = null;
  showFormUnit = false;

  showImportAlert = false

  modalUnitStateSamae = {
    params: null,
    show: false,
    message: null,
    observation: ''
  };

  async created () {
    this.datatable = this.getModalDatatable(this.forms[0])
    this.data = this.getModalResidues(this.forms[0])
    const { adjusted, user } = this.forms[1].dadosForm
    this.dadosForm.adjusted = adjusted
    this.dadosForm.user = user
  }

  async beforeMount () {
    if (this.forms.length < 3) {
      const formsUnit = await repository.resolve('consumerUnit.gravar')
      formsUnit[0].dadosForm.consumerUnitAddresss = []
      formsUnit[0].dadosForm.consumerUnitClients = []
      formsUnit[0].dadosForm.consumerUnitCategorys = []
      formsUnit[0].dadosForm.consumerUnitFiles = []
      formsUnit[0].dadosForm.consumerUnitMemos = []
      this.forms[2] = formsUnit
      this.forms = [...this.forms]
    } else {
      this.showFormUnit = true
    }
    this.datatableConsumerUnit =
      await Vue.prototype.$jt.repository.resolveDatatable(
        this.nmInterfaceConsumerUnit,
        this.params
      )
  }

  getModalDatatable (_form) {
    return _form.inputs.find((_input) => _input.type == 'DATATABLE')
  }

  getModalResidues (_form) {
    return _form.relacionamentos.fileLXSamaes
  }

  importData () {
    this.forms[2][0].dadosForm.hydroNumber = this?.model?.HD
  }

  async connectUnit () {
    if (this.dadosForm.user) {
      const { unitSamae } = this.forms[0].dadosForm
      const dadosForm = await repository.resolveLogic('samae.loadNewUnitWaste', { id: unitSamae })
      dadosForm.consumerUnitAddresss = []
      dadosForm.consumerUnitClients = []
      dadosForm.consumerUnitCategorys = []
      dadosForm.consumerUnitFiles = []
      dadosForm.consumerUnitMemos = []
      this.forms[2][0].dadosForm = { ...this.forms[2][0].dadosForm, ...dadosForm }
      this.showFormUnit = false
      this.$nextTick(() => {
        this.showFormUnit = true
      })
    } else {
      const _self = this
      this.$q
        .dialog({
          title: this.$gettext('CONFIRMATION'),
          message: this.$gettext(
            'THIS_RECORD_WILL_BE_ASSOCIATED_WITH_YOU'
          ),
          ok: this.$gettext('YES'),
          cancel: this.$gettext('NO'),
          preventClose: true
        })
        .onOk(async () => {
          const data = await _self.controller.joinUnit({
            ..._self.forms[1].dadosForm
          })
          _self.dadosForm.user = data.name

          _self.showFormUnit = false
          const { unitSamae } = _self.forms[0].dadosForm
          const dadosForm = await repository.resolveLogic('samae.loadNewUnitWaste', { id: unitSamae })
          dadosForm.consumerUnitAddresss = []
          dadosForm.consumerUnitClients = []
          dadosForm.consumerUnitCategorys = []
          dadosForm.consumerUnitFiles = []
          dadosForm.consumerUnitMemos = []
          _self.forms[2][0].dadosForm = dadosForm
          _self.showFormUnit = true
          _self.$forceUpdate()
        })
    }
  }

  btAssociar () {
    this.$q
      .dialog({
        title: this.$gettext('CONFIRMATION'),
        message: this.$gettext(
          'THIS_RECORD_WILL_BE_ASSOCIATED_WITH_YOU'
        ),
        ok: this.$gettext('YES'),
        cancel: this.$gettext('NO'),
        preventClose: true
      })
      .onOk(async () => {
        const data = await this.controller.joinUnit({
          ...this.forms[1].dadosForm
        })
        this.dadosForm.user = data.name
      })
  }

  btAnalisar () {
    if (this.$refs.consumerUnitForm.isValidForm()) {
      this.$emit(
        'action-button',
        { name: 'btAnalisar' },
        { ...this.forms[1].dadosForm },
        this
      )
    }
  }

  async detail () {
    const forms = await this.controller.unitStateSamae({
      id: JSON.parse(this.forms[0].dadosForm.unitStateSamae)[0].id
    })
    this.pageDialog = {
      page: pageDetailSamae,
      name: this.$gettext('DETAIL'),
      params: this.forms[0].dadosForm,
      forms: forms,
      parent: this
    }
    this.flModal = true
  }

  searchModalUnit () {
    this.$refs.jtSearchModal.show()
  }

  btnActionUnit (button, params) {
    switch (button.name) {
      case 'icAlterar':
        this.icAlterar(button, params)
        break
      case 'icExcluir':
        this.icExcluir(button, params)
        break
    }
  }

  icExcluir (button, params) {
    let index = null
    this.dataConsumerUnit.forEach((r, i) => {
      if (params.id == r.id) {
        index = i
      }
    })
    if (index) {
      this.dataConsumerUnit.splice(index, 1)
    }
  }

  btAssumir () {
    const _self = this
    this.$q
      .dialog({
        title: this.$gettext('CONFIRMATION'),
        message: this.$gettext(
          'THIS_RECORD_WILL_BE_ASSOCIATED_WITH_YOU'
        ),
        ok: this.$gettext('YES'),
        cancel: this.$gettext('NO'),
        preventClose: true
      })
      .onOk(async () => {
        const data = await _self.controller.joinUnit({
          ..._self.forms[1].dadosForm
        })
        _self.dadosForm.user = data.name
        _self.$forceUpdate()
      })
  }

  async icAlterar (button, params) {
    if (this.dadosForm.user) {
      this.showFormUnit = false
      const formsUnit = await repository.resolve('consumerUnit.alterar', { id: params.id })
      if (formsUnit[0].dadosForm.companyCodeWater && formsUnit[0].dadosForm.companyCodeWater != this.forms[0].dadosForm.unitSamae) {
        messageBox.error(this.$gettext('UNIT_WITH_ASSOCIATED_CONVAG_MESSAGE') + formsUnit[0].dadosForm.companyCodeWater)
        return
      }
      formsUnit[0].dadosForm.companyCodeWater = this.forms[0].dadosForm.unitSamae
      this.forms[2] = formsUnit
      this.forms = [...this.forms]
      this.importData()
      this.$nextTick(() => {
        this.showFormUnit = true
      })
    } else {
      const _self = this
      this.$q
        .dialog({
          title: this.$gettext('CONFIRMATION'),
          message: this.$gettext(
            'THIS_RECORD_WILL_BE_ASSOCIATED_WITH_YOU'
          ),
          ok: this.$gettext('YES'),
          cancel: this.$gettext('NO'),
          preventClose: true
        })
        .onOk(async () => {
          const data = await _self.controller.joinUnit({
            ..._self.forms[1].dadosForm
          })
          _self.dadosForm.user = data.name

          _self.showFormUnit = false
          const formsUnit = await repository.resolve('consumerUnit.alterar', { id: params.id })
          if (formsUnit[0].dadosForm.companyCodeWater && formsUnit[0].dadosForm.companyCodeWater != _self.forms[0].dadosForm.unitSamae) {
            messageBox.error(_self.$gettext('UNIT_WITH_ASSOCIATED_CONVAG_MESSAGE') + formsUnit[0].dadosForm.companyCodeWater)
            return
          }
          formsUnit[0].dadosForm.companyCodeWater = _self.forms[0].dadosForm.unitSamae
          _self.forms[2] = formsUnit
          _self.forms = [..._self.forms]
          _self.importData()
          _self.$nextTick(() => {
            _self.showFormUnit = true
          })
          _self.$forceUpdate()
        })
    }
  }

  getSelectedItemData (selectedItem) {
    if (selectedItem) {
      selectedItem.forEach((r) => {
        if (!this.dataConsumerUnit.find((i) => i.id == r.id)) {
          this.dataConsumerUnit.push(r)
        }
      })
    }
    this.$refs.jtSearchModal.hide()
  }

  jsonState (state) {
    if (state instanceof Array) {
      return state
    }
    return JSON.parse(state)
  }
}
export default PageAnalyze
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#analyzeSamae {
  margin-top: 30px;
  height: 400px;;
}
.analyzeSamaeForms {
  #scroll-area {
    height: 80px !important;
  }
}

for num in 1 .. 12 {
  .col-start-{num} {
    grid-column-start: num;
  }
}

for num in 1 .. 13 {
  .col-end-{num} {
    grid-column-end: num;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: max-content;
}

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-main.q-card__section {
  height: calc(100% - 65px);
  overflow: hidden;
  padding: 15px 0;
}

.data-card-main.q-card__section > div {
  padding: 5px 12px;
}

.data-card-main.q-card__section > div > label {
  font-weight: bold;
}

.row-grey {
  background: $ice;
}

.sub-teble-btn {
  color #444
  border: none;
  background-color: #fff;
  font-size: 18px !important;
  margin-left: 15px;
  cursor: pointer;
}
</style>
